import { useEffect } from 'react';

import { CustomEventNames, EventTypes, logRBIEvent } from 'state/amplitude';

export const useModalAnalyticsAppearanceEvent = (modalAppearanceEventMessage?: string | null) => {
  useEffect(() => {
    if (!modalAppearanceEventMessage) {
      return;
    }
    logModalAppearanceEvent(modalAppearanceEventMessage);
  }, [modalAppearanceEventMessage]);
};

export const logModalAppearanceEvent = (modalAppearanceEventMessage: string) => {
  logRBIEvent({
    name: CustomEventNames.MODAL_APPEARANCE,
    type: EventTypes.Other,
    attributes: {
      Message: modalAppearanceEventMessage,
      ModalHeader: modalAppearanceEventMessage,
      modalHeader: modalAppearanceEventMessage,
    },
  });
};
